/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as DashboardRouteImport } from './routes/dashboard/route'
import { Route as IndexImport } from './routes/index'
import { Route as ShareIndexImport } from './routes/share/index'
import { Route as ResetPasswordIndexImport } from './routes/reset-password/index'
import { Route as RegisterIndexImport } from './routes/register/index'
import { Route as LoginIndexImport } from './routes/login/index'
import { Route as DashboardIndexImport } from './routes/dashboard/index'
import { Route as ResetPasswordSuccessImport } from './routes/reset-password/success'
import { Route as ResetPasswordNewImport } from './routes/reset-password/new'
import { Route as ResetPasswordCodeImport } from './routes/reset-password/code'
import { Route as RegisterOnboardingImport } from './routes/register/onboarding'
import { Route as RegisterCheckoutImport } from './routes/register/checkout'
import { Route as LoginVerifyImport } from './routes/login/verify'
import { Route as ErrorDisabledImport } from './routes/error/disabled'
import { Route as SuccessChangePasswordIndexImport } from './routes/success/change-password/index'
import { Route as RegisterBetaIndexImport } from './routes/register/beta/index'
import { Route as DashboardSupportIndexImport } from './routes/dashboard/support/index'
import { Route as DashboardProfileIndexImport } from './routes/dashboard/profile/index'
import { Route as DashboardPatientsIndexImport } from './routes/dashboard/patients/index'
import { Route as DashboardBillingIndexImport } from './routes/dashboard/billing/index'
import { Route as RegisterBetaProfessionalImport } from './routes/register/beta/professional'
import { Route as RegisterBetaClinicImport } from './routes/register/beta/clinic'
import { Route as DashboardPatientsInvitesImport } from './routes/dashboard/patients/invites'
import { Route as DashboardPatientsIdImport } from './routes/dashboard/patients/$id'
import { Route as DashboardErrorGenericErrorImport } from './routes/dashboard/error/generic-error'
import { Route as DashboardProfileDeleteAccountIndexImport } from './routes/dashboard/profile/delete-account/index'
import { Route as DashboardProfileChangePasswordIndexImport } from './routes/dashboard/profile/change-password/index'
import { Route as DashboardPatientsNewIndexImport } from './routes/dashboard/patients/new/index'
import { Route as DashboardPatientsIdIndexImport } from './routes/dashboard/patients/$id/index'
import { Route as DashboardPatientsNewSentImport } from './routes/dashboard/patients/new/sent'
import { Route as DashboardPatientsNewErrorImport } from './routes/dashboard/patients/new/error'
import { Route as DashboardPatientsNewDuplicatedImport } from './routes/dashboard/patients/new/duplicated'
import { Route as DashboardPatientsIdMedicationsMedicationIdImport } from './routes/dashboard/patients/$id/medications/$medicationId'

// Create/Update Routes

const DashboardRouteRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const ShareIndexRoute = ShareIndexImport.update({
  id: '/share/',
  path: '/share/',
  getParentRoute: () => rootRoute,
} as any)

const ResetPasswordIndexRoute = ResetPasswordIndexImport.update({
  id: '/reset-password/',
  path: '/reset-password/',
  getParentRoute: () => rootRoute,
} as any)

const RegisterIndexRoute = RegisterIndexImport.update({
  id: '/register/',
  path: '/register/',
  getParentRoute: () => rootRoute,
} as any)

const LoginIndexRoute = LoginIndexImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRoute,
} as any)

const DashboardIndexRoute = DashboardIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const ResetPasswordSuccessRoute = ResetPasswordSuccessImport.update({
  id: '/reset-password/success',
  path: '/reset-password/success',
  getParentRoute: () => rootRoute,
} as any)

const ResetPasswordNewRoute = ResetPasswordNewImport.update({
  id: '/reset-password/new',
  path: '/reset-password/new',
  getParentRoute: () => rootRoute,
} as any)

const ResetPasswordCodeRoute = ResetPasswordCodeImport.update({
  id: '/reset-password/code',
  path: '/reset-password/code',
  getParentRoute: () => rootRoute,
} as any)

const RegisterOnboardingRoute = RegisterOnboardingImport.update({
  id: '/register/onboarding',
  path: '/register/onboarding',
  getParentRoute: () => rootRoute,
} as any)

const RegisterCheckoutRoute = RegisterCheckoutImport.update({
  id: '/register/checkout',
  path: '/register/checkout',
  getParentRoute: () => rootRoute,
} as any)

const LoginVerifyRoute = LoginVerifyImport.update({
  id: '/login/verify',
  path: '/login/verify',
  getParentRoute: () => rootRoute,
} as any)

const ErrorDisabledRoute = ErrorDisabledImport.update({
  id: '/error/disabled',
  path: '/error/disabled',
  getParentRoute: () => rootRoute,
} as any)

const SuccessChangePasswordIndexRoute = SuccessChangePasswordIndexImport.update(
  {
    id: '/success/change-password/',
    path: '/success/change-password/',
    getParentRoute: () => rootRoute,
  } as any,
)

const RegisterBetaIndexRoute = RegisterBetaIndexImport.update({
  id: '/register/beta/',
  path: '/register/beta/',
  getParentRoute: () => rootRoute,
} as any)

const DashboardSupportIndexRoute = DashboardSupportIndexImport.update({
  id: '/support/',
  path: '/support/',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const DashboardProfileIndexRoute = DashboardProfileIndexImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const DashboardPatientsIndexRoute = DashboardPatientsIndexImport.update({
  id: '/patients/',
  path: '/patients/',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const DashboardBillingIndexRoute = DashboardBillingIndexImport.update({
  id: '/billing/',
  path: '/billing/',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const RegisterBetaProfessionalRoute = RegisterBetaProfessionalImport.update({
  id: '/register/beta/professional',
  path: '/register/beta/professional',
  getParentRoute: () => rootRoute,
} as any)

const RegisterBetaClinicRoute = RegisterBetaClinicImport.update({
  id: '/register/beta/clinic',
  path: '/register/beta/clinic',
  getParentRoute: () => rootRoute,
} as any)

const DashboardPatientsInvitesRoute = DashboardPatientsInvitesImport.update({
  id: '/patients/invites',
  path: '/patients/invites',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const DashboardPatientsIdRoute = DashboardPatientsIdImport.update({
  id: '/patients/$id',
  path: '/patients/$id',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const DashboardErrorGenericErrorRoute = DashboardErrorGenericErrorImport.update(
  {
    id: '/error/generic-error',
    path: '/error/generic-error',
    getParentRoute: () => DashboardRouteRoute,
  } as any,
)

const DashboardProfileDeleteAccountIndexRoute =
  DashboardProfileDeleteAccountIndexImport.update({
    id: '/profile/delete-account/',
    path: '/profile/delete-account/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)

const DashboardProfileChangePasswordIndexRoute =
  DashboardProfileChangePasswordIndexImport.update({
    id: '/profile/change-password/',
    path: '/profile/change-password/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)

const DashboardPatientsNewIndexRoute = DashboardPatientsNewIndexImport.update({
  id: '/patients/new/',
  path: '/patients/new/',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const DashboardPatientsIdIndexRoute = DashboardPatientsIdIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardPatientsIdRoute,
} as any)

const DashboardPatientsNewSentRoute = DashboardPatientsNewSentImport.update({
  id: '/patients/new/sent',
  path: '/patients/new/sent',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const DashboardPatientsNewErrorRoute = DashboardPatientsNewErrorImport.update({
  id: '/patients/new/error',
  path: '/patients/new/error',
  getParentRoute: () => DashboardRouteRoute,
} as any)

const DashboardPatientsNewDuplicatedRoute =
  DashboardPatientsNewDuplicatedImport.update({
    id: '/patients/new/duplicated',
    path: '/patients/new/duplicated',
    getParentRoute: () => DashboardRouteRoute,
  } as any)

const DashboardPatientsIdMedicationsMedicationIdRoute =
  DashboardPatientsIdMedicationsMedicationIdImport.update({
    id: '/medications/$medicationId',
    path: '/medications/$medicationId',
    getParentRoute: () => DashboardPatientsIdRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRoute
    }
    '/error/disabled': {
      id: '/error/disabled'
      path: '/error/disabled'
      fullPath: '/error/disabled'
      preLoaderRoute: typeof ErrorDisabledImport
      parentRoute: typeof rootRoute
    }
    '/login/verify': {
      id: '/login/verify'
      path: '/login/verify'
      fullPath: '/login/verify'
      preLoaderRoute: typeof LoginVerifyImport
      parentRoute: typeof rootRoute
    }
    '/register/checkout': {
      id: '/register/checkout'
      path: '/register/checkout'
      fullPath: '/register/checkout'
      preLoaderRoute: typeof RegisterCheckoutImport
      parentRoute: typeof rootRoute
    }
    '/register/onboarding': {
      id: '/register/onboarding'
      path: '/register/onboarding'
      fullPath: '/register/onboarding'
      preLoaderRoute: typeof RegisterOnboardingImport
      parentRoute: typeof rootRoute
    }
    '/reset-password/code': {
      id: '/reset-password/code'
      path: '/reset-password/code'
      fullPath: '/reset-password/code'
      preLoaderRoute: typeof ResetPasswordCodeImport
      parentRoute: typeof rootRoute
    }
    '/reset-password/new': {
      id: '/reset-password/new'
      path: '/reset-password/new'
      fullPath: '/reset-password/new'
      preLoaderRoute: typeof ResetPasswordNewImport
      parentRoute: typeof rootRoute
    }
    '/reset-password/success': {
      id: '/reset-password/success'
      path: '/reset-password/success'
      fullPath: '/reset-password/success'
      preLoaderRoute: typeof ResetPasswordSuccessImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexImport
      parentRoute: typeof DashboardRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginIndexImport
      parentRoute: typeof rootRoute
    }
    '/register/': {
      id: '/register/'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterIndexImport
      parentRoute: typeof rootRoute
    }
    '/reset-password/': {
      id: '/reset-password/'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordIndexImport
      parentRoute: typeof rootRoute
    }
    '/share/': {
      id: '/share/'
      path: '/share'
      fullPath: '/share'
      preLoaderRoute: typeof ShareIndexImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/error/generic-error': {
      id: '/dashboard/error/generic-error'
      path: '/error/generic-error'
      fullPath: '/dashboard/error/generic-error'
      preLoaderRoute: typeof DashboardErrorGenericErrorImport
      parentRoute: typeof DashboardRouteImport
    }
    '/dashboard/patients/$id': {
      id: '/dashboard/patients/$id'
      path: '/patients/$id'
      fullPath: '/dashboard/patients/$id'
      preLoaderRoute: typeof DashboardPatientsIdImport
      parentRoute: typeof DashboardRouteImport
    }
    '/dashboard/patients/invites': {
      id: '/dashboard/patients/invites'
      path: '/patients/invites'
      fullPath: '/dashboard/patients/invites'
      preLoaderRoute: typeof DashboardPatientsInvitesImport
      parentRoute: typeof DashboardRouteImport
    }
    '/register/beta/clinic': {
      id: '/register/beta/clinic'
      path: '/register/beta/clinic'
      fullPath: '/register/beta/clinic'
      preLoaderRoute: typeof RegisterBetaClinicImport
      parentRoute: typeof rootRoute
    }
    '/register/beta/professional': {
      id: '/register/beta/professional'
      path: '/register/beta/professional'
      fullPath: '/register/beta/professional'
      preLoaderRoute: typeof RegisterBetaProfessionalImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/billing/': {
      id: '/dashboard/billing/'
      path: '/billing'
      fullPath: '/dashboard/billing'
      preLoaderRoute: typeof DashboardBillingIndexImport
      parentRoute: typeof DashboardRouteImport
    }
    '/dashboard/patients/': {
      id: '/dashboard/patients/'
      path: '/patients'
      fullPath: '/dashboard/patients'
      preLoaderRoute: typeof DashboardPatientsIndexImport
      parentRoute: typeof DashboardRouteImport
    }
    '/dashboard/profile/': {
      id: '/dashboard/profile/'
      path: '/profile'
      fullPath: '/dashboard/profile'
      preLoaderRoute: typeof DashboardProfileIndexImport
      parentRoute: typeof DashboardRouteImport
    }
    '/dashboard/support/': {
      id: '/dashboard/support/'
      path: '/support'
      fullPath: '/dashboard/support'
      preLoaderRoute: typeof DashboardSupportIndexImport
      parentRoute: typeof DashboardRouteImport
    }
    '/register/beta/': {
      id: '/register/beta/'
      path: '/register/beta'
      fullPath: '/register/beta'
      preLoaderRoute: typeof RegisterBetaIndexImport
      parentRoute: typeof rootRoute
    }
    '/success/change-password/': {
      id: '/success/change-password/'
      path: '/success/change-password'
      fullPath: '/success/change-password'
      preLoaderRoute: typeof SuccessChangePasswordIndexImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/patients/new/duplicated': {
      id: '/dashboard/patients/new/duplicated'
      path: '/patients/new/duplicated'
      fullPath: '/dashboard/patients/new/duplicated'
      preLoaderRoute: typeof DashboardPatientsNewDuplicatedImport
      parentRoute: typeof DashboardRouteImport
    }
    '/dashboard/patients/new/error': {
      id: '/dashboard/patients/new/error'
      path: '/patients/new/error'
      fullPath: '/dashboard/patients/new/error'
      preLoaderRoute: typeof DashboardPatientsNewErrorImport
      parentRoute: typeof DashboardRouteImport
    }
    '/dashboard/patients/new/sent': {
      id: '/dashboard/patients/new/sent'
      path: '/patients/new/sent'
      fullPath: '/dashboard/patients/new/sent'
      preLoaderRoute: typeof DashboardPatientsNewSentImport
      parentRoute: typeof DashboardRouteImport
    }
    '/dashboard/patients/$id/': {
      id: '/dashboard/patients/$id/'
      path: '/'
      fullPath: '/dashboard/patients/$id/'
      preLoaderRoute: typeof DashboardPatientsIdIndexImport
      parentRoute: typeof DashboardPatientsIdImport
    }
    '/dashboard/patients/new/': {
      id: '/dashboard/patients/new/'
      path: '/patients/new'
      fullPath: '/dashboard/patients/new'
      preLoaderRoute: typeof DashboardPatientsNewIndexImport
      parentRoute: typeof DashboardRouteImport
    }
    '/dashboard/profile/change-password/': {
      id: '/dashboard/profile/change-password/'
      path: '/profile/change-password'
      fullPath: '/dashboard/profile/change-password'
      preLoaderRoute: typeof DashboardProfileChangePasswordIndexImport
      parentRoute: typeof DashboardRouteImport
    }
    '/dashboard/profile/delete-account/': {
      id: '/dashboard/profile/delete-account/'
      path: '/profile/delete-account'
      fullPath: '/dashboard/profile/delete-account'
      preLoaderRoute: typeof DashboardProfileDeleteAccountIndexImport
      parentRoute: typeof DashboardRouteImport
    }
    '/dashboard/patients/$id/medications/$medicationId': {
      id: '/dashboard/patients/$id/medications/$medicationId'
      path: '/medications/$medicationId'
      fullPath: '/dashboard/patients/$id/medications/$medicationId'
      preLoaderRoute: typeof DashboardPatientsIdMedicationsMedicationIdImport
      parentRoute: typeof DashboardPatientsIdImport
    }
  }
}

// Create and export the route tree

interface DashboardPatientsIdRouteChildren {
  DashboardPatientsIdIndexRoute: typeof DashboardPatientsIdIndexRoute
  DashboardPatientsIdMedicationsMedicationIdRoute: typeof DashboardPatientsIdMedicationsMedicationIdRoute
}

const DashboardPatientsIdRouteChildren: DashboardPatientsIdRouteChildren = {
  DashboardPatientsIdIndexRoute: DashboardPatientsIdIndexRoute,
  DashboardPatientsIdMedicationsMedicationIdRoute:
    DashboardPatientsIdMedicationsMedicationIdRoute,
}

const DashboardPatientsIdRouteWithChildren =
  DashboardPatientsIdRoute._addFileChildren(DashboardPatientsIdRouteChildren)

interface DashboardRouteRouteChildren {
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardErrorGenericErrorRoute: typeof DashboardErrorGenericErrorRoute
  DashboardPatientsIdRoute: typeof DashboardPatientsIdRouteWithChildren
  DashboardPatientsInvitesRoute: typeof DashboardPatientsInvitesRoute
  DashboardBillingIndexRoute: typeof DashboardBillingIndexRoute
  DashboardPatientsIndexRoute: typeof DashboardPatientsIndexRoute
  DashboardProfileIndexRoute: typeof DashboardProfileIndexRoute
  DashboardSupportIndexRoute: typeof DashboardSupportIndexRoute
  DashboardPatientsNewDuplicatedRoute: typeof DashboardPatientsNewDuplicatedRoute
  DashboardPatientsNewErrorRoute: typeof DashboardPatientsNewErrorRoute
  DashboardPatientsNewSentRoute: typeof DashboardPatientsNewSentRoute
  DashboardPatientsNewIndexRoute: typeof DashboardPatientsNewIndexRoute
  DashboardProfileChangePasswordIndexRoute: typeof DashboardProfileChangePasswordIndexRoute
  DashboardProfileDeleteAccountIndexRoute: typeof DashboardProfileDeleteAccountIndexRoute
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardErrorGenericErrorRoute: DashboardErrorGenericErrorRoute,
  DashboardPatientsIdRoute: DashboardPatientsIdRouteWithChildren,
  DashboardPatientsInvitesRoute: DashboardPatientsInvitesRoute,
  DashboardBillingIndexRoute: DashboardBillingIndexRoute,
  DashboardPatientsIndexRoute: DashboardPatientsIndexRoute,
  DashboardProfileIndexRoute: DashboardProfileIndexRoute,
  DashboardSupportIndexRoute: DashboardSupportIndexRoute,
  DashboardPatientsNewDuplicatedRoute: DashboardPatientsNewDuplicatedRoute,
  DashboardPatientsNewErrorRoute: DashboardPatientsNewErrorRoute,
  DashboardPatientsNewSentRoute: DashboardPatientsNewSentRoute,
  DashboardPatientsNewIndexRoute: DashboardPatientsNewIndexRoute,
  DashboardProfileChangePasswordIndexRoute:
    DashboardProfileChangePasswordIndexRoute,
  DashboardProfileDeleteAccountIndexRoute:
    DashboardProfileDeleteAccountIndexRoute,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/error/disabled': typeof ErrorDisabledRoute
  '/login/verify': typeof LoginVerifyRoute
  '/register/checkout': typeof RegisterCheckoutRoute
  '/register/onboarding': typeof RegisterOnboardingRoute
  '/reset-password/code': typeof ResetPasswordCodeRoute
  '/reset-password/new': typeof ResetPasswordNewRoute
  '/reset-password/success': typeof ResetPasswordSuccessRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/login': typeof LoginIndexRoute
  '/register': typeof RegisterIndexRoute
  '/reset-password': typeof ResetPasswordIndexRoute
  '/share': typeof ShareIndexRoute
  '/dashboard/error/generic-error': typeof DashboardErrorGenericErrorRoute
  '/dashboard/patients/$id': typeof DashboardPatientsIdRouteWithChildren
  '/dashboard/patients/invites': typeof DashboardPatientsInvitesRoute
  '/register/beta/clinic': typeof RegisterBetaClinicRoute
  '/register/beta/professional': typeof RegisterBetaProfessionalRoute
  '/dashboard/billing': typeof DashboardBillingIndexRoute
  '/dashboard/patients': typeof DashboardPatientsIndexRoute
  '/dashboard/profile': typeof DashboardProfileIndexRoute
  '/dashboard/support': typeof DashboardSupportIndexRoute
  '/register/beta': typeof RegisterBetaIndexRoute
  '/success/change-password': typeof SuccessChangePasswordIndexRoute
  '/dashboard/patients/new/duplicated': typeof DashboardPatientsNewDuplicatedRoute
  '/dashboard/patients/new/error': typeof DashboardPatientsNewErrorRoute
  '/dashboard/patients/new/sent': typeof DashboardPatientsNewSentRoute
  '/dashboard/patients/$id/': typeof DashboardPatientsIdIndexRoute
  '/dashboard/patients/new': typeof DashboardPatientsNewIndexRoute
  '/dashboard/profile/change-password': typeof DashboardProfileChangePasswordIndexRoute
  '/dashboard/profile/delete-account': typeof DashboardProfileDeleteAccountIndexRoute
  '/dashboard/patients/$id/medications/$medicationId': typeof DashboardPatientsIdMedicationsMedicationIdRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/error/disabled': typeof ErrorDisabledRoute
  '/login/verify': typeof LoginVerifyRoute
  '/register/checkout': typeof RegisterCheckoutRoute
  '/register/onboarding': typeof RegisterOnboardingRoute
  '/reset-password/code': typeof ResetPasswordCodeRoute
  '/reset-password/new': typeof ResetPasswordNewRoute
  '/reset-password/success': typeof ResetPasswordSuccessRoute
  '/dashboard': typeof DashboardIndexRoute
  '/login': typeof LoginIndexRoute
  '/register': typeof RegisterIndexRoute
  '/reset-password': typeof ResetPasswordIndexRoute
  '/share': typeof ShareIndexRoute
  '/dashboard/error/generic-error': typeof DashboardErrorGenericErrorRoute
  '/dashboard/patients/invites': typeof DashboardPatientsInvitesRoute
  '/register/beta/clinic': typeof RegisterBetaClinicRoute
  '/register/beta/professional': typeof RegisterBetaProfessionalRoute
  '/dashboard/billing': typeof DashboardBillingIndexRoute
  '/dashboard/patients': typeof DashboardPatientsIndexRoute
  '/dashboard/profile': typeof DashboardProfileIndexRoute
  '/dashboard/support': typeof DashboardSupportIndexRoute
  '/register/beta': typeof RegisterBetaIndexRoute
  '/success/change-password': typeof SuccessChangePasswordIndexRoute
  '/dashboard/patients/new/duplicated': typeof DashboardPatientsNewDuplicatedRoute
  '/dashboard/patients/new/error': typeof DashboardPatientsNewErrorRoute
  '/dashboard/patients/new/sent': typeof DashboardPatientsNewSentRoute
  '/dashboard/patients/$id': typeof DashboardPatientsIdIndexRoute
  '/dashboard/patients/new': typeof DashboardPatientsNewIndexRoute
  '/dashboard/profile/change-password': typeof DashboardProfileChangePasswordIndexRoute
  '/dashboard/profile/delete-account': typeof DashboardProfileDeleteAccountIndexRoute
  '/dashboard/patients/$id/medications/$medicationId': typeof DashboardPatientsIdMedicationsMedicationIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/error/disabled': typeof ErrorDisabledRoute
  '/login/verify': typeof LoginVerifyRoute
  '/register/checkout': typeof RegisterCheckoutRoute
  '/register/onboarding': typeof RegisterOnboardingRoute
  '/reset-password/code': typeof ResetPasswordCodeRoute
  '/reset-password/new': typeof ResetPasswordNewRoute
  '/reset-password/success': typeof ResetPasswordSuccessRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/login/': typeof LoginIndexRoute
  '/register/': typeof RegisterIndexRoute
  '/reset-password/': typeof ResetPasswordIndexRoute
  '/share/': typeof ShareIndexRoute
  '/dashboard/error/generic-error': typeof DashboardErrorGenericErrorRoute
  '/dashboard/patients/$id': typeof DashboardPatientsIdRouteWithChildren
  '/dashboard/patients/invites': typeof DashboardPatientsInvitesRoute
  '/register/beta/clinic': typeof RegisterBetaClinicRoute
  '/register/beta/professional': typeof RegisterBetaProfessionalRoute
  '/dashboard/billing/': typeof DashboardBillingIndexRoute
  '/dashboard/patients/': typeof DashboardPatientsIndexRoute
  '/dashboard/profile/': typeof DashboardProfileIndexRoute
  '/dashboard/support/': typeof DashboardSupportIndexRoute
  '/register/beta/': typeof RegisterBetaIndexRoute
  '/success/change-password/': typeof SuccessChangePasswordIndexRoute
  '/dashboard/patients/new/duplicated': typeof DashboardPatientsNewDuplicatedRoute
  '/dashboard/patients/new/error': typeof DashboardPatientsNewErrorRoute
  '/dashboard/patients/new/sent': typeof DashboardPatientsNewSentRoute
  '/dashboard/patients/$id/': typeof DashboardPatientsIdIndexRoute
  '/dashboard/patients/new/': typeof DashboardPatientsNewIndexRoute
  '/dashboard/profile/change-password/': typeof DashboardProfileChangePasswordIndexRoute
  '/dashboard/profile/delete-account/': typeof DashboardProfileDeleteAccountIndexRoute
  '/dashboard/patients/$id/medications/$medicationId': typeof DashboardPatientsIdMedicationsMedicationIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/error/disabled'
    | '/login/verify'
    | '/register/checkout'
    | '/register/onboarding'
    | '/reset-password/code'
    | '/reset-password/new'
    | '/reset-password/success'
    | '/dashboard/'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/share'
    | '/dashboard/error/generic-error'
    | '/dashboard/patients/$id'
    | '/dashboard/patients/invites'
    | '/register/beta/clinic'
    | '/register/beta/professional'
    | '/dashboard/billing'
    | '/dashboard/patients'
    | '/dashboard/profile'
    | '/dashboard/support'
    | '/register/beta'
    | '/success/change-password'
    | '/dashboard/patients/new/duplicated'
    | '/dashboard/patients/new/error'
    | '/dashboard/patients/new/sent'
    | '/dashboard/patients/$id/'
    | '/dashboard/patients/new'
    | '/dashboard/profile/change-password'
    | '/dashboard/profile/delete-account'
    | '/dashboard/patients/$id/medications/$medicationId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/error/disabled'
    | '/login/verify'
    | '/register/checkout'
    | '/register/onboarding'
    | '/reset-password/code'
    | '/reset-password/new'
    | '/reset-password/success'
    | '/dashboard'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/share'
    | '/dashboard/error/generic-error'
    | '/dashboard/patients/invites'
    | '/register/beta/clinic'
    | '/register/beta/professional'
    | '/dashboard/billing'
    | '/dashboard/patients'
    | '/dashboard/profile'
    | '/dashboard/support'
    | '/register/beta'
    | '/success/change-password'
    | '/dashboard/patients/new/duplicated'
    | '/dashboard/patients/new/error'
    | '/dashboard/patients/new/sent'
    | '/dashboard/patients/$id'
    | '/dashboard/patients/new'
    | '/dashboard/profile/change-password'
    | '/dashboard/profile/delete-account'
    | '/dashboard/patients/$id/medications/$medicationId'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/error/disabled'
    | '/login/verify'
    | '/register/checkout'
    | '/register/onboarding'
    | '/reset-password/code'
    | '/reset-password/new'
    | '/reset-password/success'
    | '/dashboard/'
    | '/login/'
    | '/register/'
    | '/reset-password/'
    | '/share/'
    | '/dashboard/error/generic-error'
    | '/dashboard/patients/$id'
    | '/dashboard/patients/invites'
    | '/register/beta/clinic'
    | '/register/beta/professional'
    | '/dashboard/billing/'
    | '/dashboard/patients/'
    | '/dashboard/profile/'
    | '/dashboard/support/'
    | '/register/beta/'
    | '/success/change-password/'
    | '/dashboard/patients/new/duplicated'
    | '/dashboard/patients/new/error'
    | '/dashboard/patients/new/sent'
    | '/dashboard/patients/$id/'
    | '/dashboard/patients/new/'
    | '/dashboard/profile/change-password/'
    | '/dashboard/profile/delete-account/'
    | '/dashboard/patients/$id/medications/$medicationId'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
  ErrorDisabledRoute: typeof ErrorDisabledRoute
  LoginVerifyRoute: typeof LoginVerifyRoute
  RegisterCheckoutRoute: typeof RegisterCheckoutRoute
  RegisterOnboardingRoute: typeof RegisterOnboardingRoute
  ResetPasswordCodeRoute: typeof ResetPasswordCodeRoute
  ResetPasswordNewRoute: typeof ResetPasswordNewRoute
  ResetPasswordSuccessRoute: typeof ResetPasswordSuccessRoute
  LoginIndexRoute: typeof LoginIndexRoute
  RegisterIndexRoute: typeof RegisterIndexRoute
  ResetPasswordIndexRoute: typeof ResetPasswordIndexRoute
  ShareIndexRoute: typeof ShareIndexRoute
  RegisterBetaClinicRoute: typeof RegisterBetaClinicRoute
  RegisterBetaProfessionalRoute: typeof RegisterBetaProfessionalRoute
  RegisterBetaIndexRoute: typeof RegisterBetaIndexRoute
  SuccessChangePasswordIndexRoute: typeof SuccessChangePasswordIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
  ErrorDisabledRoute: ErrorDisabledRoute,
  LoginVerifyRoute: LoginVerifyRoute,
  RegisterCheckoutRoute: RegisterCheckoutRoute,
  RegisterOnboardingRoute: RegisterOnboardingRoute,
  ResetPasswordCodeRoute: ResetPasswordCodeRoute,
  ResetPasswordNewRoute: ResetPasswordNewRoute,
  ResetPasswordSuccessRoute: ResetPasswordSuccessRoute,
  LoginIndexRoute: LoginIndexRoute,
  RegisterIndexRoute: RegisterIndexRoute,
  ResetPasswordIndexRoute: ResetPasswordIndexRoute,
  ShareIndexRoute: ShareIndexRoute,
  RegisterBetaClinicRoute: RegisterBetaClinicRoute,
  RegisterBetaProfessionalRoute: RegisterBetaProfessionalRoute,
  RegisterBetaIndexRoute: RegisterBetaIndexRoute,
  SuccessChangePasswordIndexRoute: SuccessChangePasswordIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/dashboard",
        "/error/disabled",
        "/login/verify",
        "/register/checkout",
        "/register/onboarding",
        "/reset-password/code",
        "/reset-password/new",
        "/reset-password/success",
        "/login/",
        "/register/",
        "/reset-password/",
        "/share/",
        "/register/beta/clinic",
        "/register/beta/professional",
        "/register/beta/",
        "/success/change-password/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/dashboard": {
      "filePath": "dashboard/route.tsx",
      "children": [
        "/dashboard/",
        "/dashboard/error/generic-error",
        "/dashboard/patients/$id",
        "/dashboard/patients/invites",
        "/dashboard/billing/",
        "/dashboard/patients/",
        "/dashboard/profile/",
        "/dashboard/support/",
        "/dashboard/patients/new/duplicated",
        "/dashboard/patients/new/error",
        "/dashboard/patients/new/sent",
        "/dashboard/patients/new/",
        "/dashboard/profile/change-password/",
        "/dashboard/profile/delete-account/"
      ]
    },
    "/error/disabled": {
      "filePath": "error/disabled.tsx"
    },
    "/login/verify": {
      "filePath": "login/verify.tsx"
    },
    "/register/checkout": {
      "filePath": "register/checkout.tsx"
    },
    "/register/onboarding": {
      "filePath": "register/onboarding.tsx"
    },
    "/reset-password/code": {
      "filePath": "reset-password/code.tsx"
    },
    "/reset-password/new": {
      "filePath": "reset-password/new.tsx"
    },
    "/reset-password/success": {
      "filePath": "reset-password/success.tsx"
    },
    "/dashboard/": {
      "filePath": "dashboard/index.tsx",
      "parent": "/dashboard"
    },
    "/login/": {
      "filePath": "login/index.tsx"
    },
    "/register/": {
      "filePath": "register/index.tsx"
    },
    "/reset-password/": {
      "filePath": "reset-password/index.tsx"
    },
    "/share/": {
      "filePath": "share/index.tsx"
    },
    "/dashboard/error/generic-error": {
      "filePath": "dashboard/error/generic-error.tsx",
      "parent": "/dashboard"
    },
    "/dashboard/patients/$id": {
      "filePath": "dashboard/patients/$id.tsx",
      "parent": "/dashboard",
      "children": [
        "/dashboard/patients/$id/",
        "/dashboard/patients/$id/medications/$medicationId"
      ]
    },
    "/dashboard/patients/invites": {
      "filePath": "dashboard/patients/invites.tsx",
      "parent": "/dashboard"
    },
    "/register/beta/clinic": {
      "filePath": "register/beta/clinic.tsx"
    },
    "/register/beta/professional": {
      "filePath": "register/beta/professional.tsx"
    },
    "/dashboard/billing/": {
      "filePath": "dashboard/billing/index.tsx",
      "parent": "/dashboard"
    },
    "/dashboard/patients/": {
      "filePath": "dashboard/patients/index.tsx",
      "parent": "/dashboard"
    },
    "/dashboard/profile/": {
      "filePath": "dashboard/profile/index.tsx",
      "parent": "/dashboard"
    },
    "/dashboard/support/": {
      "filePath": "dashboard/support/index.tsx",
      "parent": "/dashboard"
    },
    "/register/beta/": {
      "filePath": "register/beta/index.tsx"
    },
    "/success/change-password/": {
      "filePath": "success/change-password/index.tsx"
    },
    "/dashboard/patients/new/duplicated": {
      "filePath": "dashboard/patients/new/duplicated.tsx",
      "parent": "/dashboard"
    },
    "/dashboard/patients/new/error": {
      "filePath": "dashboard/patients/new/error.tsx",
      "parent": "/dashboard"
    },
    "/dashboard/patients/new/sent": {
      "filePath": "dashboard/patients/new/sent.tsx",
      "parent": "/dashboard"
    },
    "/dashboard/patients/$id/": {
      "filePath": "dashboard/patients/$id/index.tsx",
      "parent": "/dashboard/patients/$id"
    },
    "/dashboard/patients/new/": {
      "filePath": "dashboard/patients/new/index.tsx",
      "parent": "/dashboard"
    },
    "/dashboard/profile/change-password/": {
      "filePath": "dashboard/profile/change-password/index.tsx",
      "parent": "/dashboard"
    },
    "/dashboard/profile/delete-account/": {
      "filePath": "dashboard/profile/delete-account/index.tsx",
      "parent": "/dashboard"
    },
    "/dashboard/patients/$id/medications/$medicationId": {
      "filePath": "dashboard/patients/$id/medications/$medicationId.tsx",
      "parent": "/dashboard/patients/$id"
    }
  }
}
ROUTE_MANIFEST_END */
